export var CHECKBOX_CLASS_PREFIX = 'Checkbox';
export var checkboxIdPrefix = 'checkbox-id-';
export var CHECKBOX_CHECK_TYPE_DASH = 'dash';
export var CHECKBOX_CHECK_TYPE_TICK = 'tick';